import { useMutation, useQueryClient, } from '@tanstack/react-query';
import produce from 'immer';
import { useUserUUID } from '@annunciate/core';
import { DOWNLOAD_CACHE_KEY, removeDownloads } from '../../utils';
export const useDownloadCancelOrDeleteMutation = (options) => {
    const uuid = useUserUUID(true);
    const client = useQueryClient();
    return useMutation({
        mutationFn: async (item) => {
            return removeDownloads({ uuid, items: [item], client });
        },
        onSuccess: (data) => {
            client.setQueryData([DOWNLOAD_CACHE_KEY], (input) => {
                return produce(input || [], (draft) => {
                    const map = data.reduce((acc, item) => {
                        acc[item.id] = item;
                        return acc;
                    }, {});
                    return draft.reduce((acc, item) => {
                        if (!map[item.id]) {
                            acc.push(item);
                        }
                        return acc;
                    }, []);
                });
            });
            data.forEach((item) => {
                client.setQueryData([`${DOWNLOAD_CACHE_KEY}:${uuid}`, { id: item.id }], false);
            });
        },
        ...options,
    });
};
//# sourceMappingURL=useDownloadCancelOrDeleteMutation.js.map